<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} ITEM</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- Image Container -->
        <!-- <template v-if="dataImg">
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataImg" alt="img" class="responsive">
          </div>
        </template> -->

        <!-- NAME -->
        <vs-input label="Name" v-model="dataName" class="mt-5 w-full" name="item-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

        <!-- CATEGORY -->
        <vs-select v-model="dataCategory" label="Category" class="mt-5 w-full" name="item-category" v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in category_choices" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-category')">{{ errors.first('item-category') }}</span>

        <!-- STATUS -->
        <!-- <vs-select v-model="dataOrder_status" label="Status" class="mt-5 w-full">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in order_status_choices" />
        </vs-select> -->

        <!-- PRICE -->
        <vs-input
          label="Price"
          v-model="dataPrice"
          class="mt-5 w-full"
          name="item-price" />
        <span class="text-danger text-sm" v-show="errors.has('item-price')">{{ errors.first('item-price') }}</span>

      
        <!-- BRAND -->
        <vs-input label="Brand" v-model="dataBrand" class="mt-5 w-full" name="item-brand" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-brand')">{{ errors.first('item-brand') }}</span>

        <!-- CONTENTS -->
        <vs-input label="Contents" v-model="dataContents" class="mt-5 w-full" name="item-contents" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-contents')">{{ errors.first('item-contents') }}</span>

        <!-- DESCRIPTION -->
        <vs-input label="Description" v-model="dataDescription" class="mt-5 w-full" name="item-description" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-description')">{{ errors.first('item-description') }}</span>

        <!-- FEATURES -->
        <vs-input label="Features" v-model="dataFeatures" class="mt-5 w-full" name="item-features" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-features')">{{ errors.first('item-features') }}</span>


        <!-- MODULE LEVEL -->
        <vs-select v-model="dataModuleLevel" label="Module Level" class="mt-5 w-full" name="item-moduleLevel" v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in moduleLevel_choices" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-moduleLevel')">{{ errors.first('item-moduleLevel') }}</span>

        <!-- PID -->
        <vs-input label="Pid" v-model="dataPid" class="mt-5 w-full" name="item-pid" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-pid')">{{ errors.first('item-pid') }}</span>

        <!-- Add courses -->

        <vs-select
          placeholder="Link courses"
          multiple
          autocomplete
          class="selectExample mt-5 w-full"
          name="item-cid"
          label="Courses"
          v-model="addedCourses"
          >
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in courseList" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-cid')">{{ errors.first('item-cid') }}</span>

        <!-- <h5>{{addedCourses}}</h5> -->
        <!-- TAGS -->
        <vs-input label="Tags" v-model="dataTags" class="mt-5 w-full" name="item-tags" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-tags')">{{ errors.first('item-tags') }}</span>

        <!-- TYPE -->
        <vs-input label="Type" v-model="dataType" class="mt-5 w-full" name="item-type" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-type')">{{ errors.first('item-type') }}</span>

        <!-- Upload -->
        <!-- <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" /> -->

        <div class="upload-img mt-5" >
          <input type="file" multiple class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
        </div>
      </div>
      <!-- Listing image files uploaded -->
      <template v-if="uplaodedFiles.length !== 0">
          <!-- Image Container -->
          <div :data="tr" :key="indextr" v-for="(tr, indextr) in uplaodedFiles">
            <div class=" w-64 mx-auto flex items-center justify-center">
            <span>{{tr.name}}</span>
            <feather-icon icon="XIcon" @click="removeUplaodedImage(indextr)" class="cursor-pointer"></feather-icon>

          </div>
          </div>
      </template>

      <!-- Listing iamge urls names from DB -->
      <template v-if="dataAllImages.length !== 0">
          <div :data="tr" :key="indextr" v-for="(tr, indextr) in dataAllImages">
            <div class=" w-64 mx-auto flex items-center justify-center">
            <span v-if="tr.name">{{tr.name.substr(15)}}</span>
            <feather-icon icon="XIcon" @click="removeImage(indextr)" class="cursor-pointer"></feather-icon>
          </div>
          </div>
      </template>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {

      dataId: null,
      dataName: '',
      dataCategory: null,
      dataImg: null,
      dataPrice: 0,
      uplaodedFiles: [],
      dataAllImages: [],

      dataBrand:null,
      dataContents:null,
      dataDescription:null,
      dataFeatures:null,
      dataModuleLevel:null,
      dataPid:null,
      dataTags:null,
      dataType:null,
      addedCourses: [],

      category_choices: [
        {text:'Micro Controller Kitwww', value:'Micro Controller Kitwww'},
        {text:'Micro Controller Kit', value:'Micro Controller Kit'}
      ],

      moduleLevel_choices: [
        {text:'Basic', value:'Basic'},
        {text:'Intermediate', value:'Intermediate'},
        {text:'Advanced', value:'Advanced'}
      ],

      // courseList:[
      //   {text: 'Square', value: 1},
      //   {text: 'Rectangle', value: 2},
      //   {text: 'Rombo', value: 3},
      //   {text: 'Romboid', value: 4},
      //   {text: 'Trapeze', value: 5},
      //   {text: 'Triangle', value: 6}
      // ],

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { category, id, allImgUrls, name, priceAmount, brand, contents, description, features, moduleLevel, pid, tags, type, courses} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataCategory = category
        this.uplaodedFiles = []
        this.dataAllImages = [...allImgUrls]
        this.dataName = name
        this.dataPrice = priceAmount

        this.dataBrand = brand
        this.dataContents = contents
        this.dataDescription = description
        this.dataFeatures = features
        this.dataModuleLevel = moduleLevel
        this.dataPid = pid
        this.dataTags = tags
        this.dataType = type
        this.addedCourses = courses

        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    courseList () {
      const choices = []
      const list =  this.$store.state.products.courseList
      if (list) {
        list.forEach(course => {
          if (course.cid && course._id) {
            choices.push({
              text: course.cid, 
              value: `${course._id}`
            })
          }
        })
      }
      return choices
    },
    isFormValid () {
      return !this.errors.any() && this.dataName && this.dataCategory && this.dataPrice > 0
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
      this.dataCategory = null
      this.dataPrice = 0
      this.dataImg = null
      this.uplaodedFiles = []
      this.dataAllImages = []

      this.dataBrand = null
      this.dataContents = null
      this.dataDescription = null
      this.dataFeatures = null
      this.dataModuleLevel = null
      this.dataPid = null
      this.dataTags = null
      this.dataType = null
      this.addedCourses = []
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name: this.dataName,
            files: this.uplaodedFiles,
            category: this.dataCategory,
            priceAmount: this.dataPrice,

            brand: this.dataBrand,
            contents : this.dataContents, 
            description : this.dataDescription, 
            features  : this.dataFeatures,
            moduleLevel : this.dataModuleLevel, 
            pid : this.dataPid,
            tags : this.dataTags,
            type : this.dataType,
            courses : this.addedCourses 
          }

          if (this.dataId !== null) {
            obj.allImgUrls = this.dataAllImages
            // console.log('check all iamge', obj)
            this.$store.dispatch('products/updateProduct', obj)
              .then(response => {
                this.successMsg(response.data.data)
              })
              .catch((err) => {
                console.error(err)
                this.errorMsg(err)
              })
          } else {
            delete obj.id
            //obj.popularity = 0
            // obj.largeImgUrl = 'image_url'
            this.$store.dispatch('products/addProduct', obj)
              .then(response => {
                this.successMsg(`${response.data.data[0].name} added`)
              })
              .catch((err) => {
                console.error(err)
                this.errorMsg(err)
              })
          }

          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    },
    updateCurrImg (input) {
      // console.log('image input', input.target.files[0])
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        this.dataImg = input.target.files[0]
        this.uplaodedFiles = [...this.uplaodedFiles, ...input.target.files]
        // console.log('multiple images', this.uplaodedFiles)
        // reader.onload = e => {
        //   this.uplaodedFiles = e.target.result
        // }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    removeUplaodedImage (input) {
      this.uplaodedFiles.splice(input, 1)
      // console.log('final uploaded image list', this.uplaodedFiles)
    },
    removeImage (input) {
      this.dataAllImages.splice(input, 1)
      // console.log('update image list', this.dataAllImages)
    },
    successMsg (message) {
      this.$vs.notify({
        title: 'Success',
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    errorMsg (errMsg) {
      this.$vs.notify({
        title: 'Failed',
        text: errMsg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    }
  },
  created () {
    // if (!moduleProductManagement.isRegistered) {
    //   this.$store.registerModule('courseList', moduleProductManagement)
    //   moduleProductManagement.isRegistered = true
    // }
    this.$store.dispatch('products/fetchCourseList')
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
